import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Dialog from 'components/organisms/Dialogs/Dialog/Dialog';
import FormStyles from 'styles/mixins/Form.styles';

const StyledTourDialog = styled(Dialog)`
  .MuiDialog-paper {
    min-width: clamp(0px, ${props => props.theme.layout(520)}, 86vw);
    max-width: clamp(0px, ${props => props.theme.layout(520)}, 86vw);
  }

  .TourDialog {
    &-content {
      display: flex;
      flex-direction: column;
      gap: ${props => props.theme.layout('2sp')};
    }
  }

  ${FormStyles}
  ${ComponentStyles}
`;

StyledTourDialog.propTypes = {
  theme: PropTypes.object
};

export default StyledTourDialog;
